import { InputSkeleton, TextareaSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  RightSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

import { TermsConditionsLoader } from '../shared/components/terms-conditions/terms-conditions-loader';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <TextareaSkeleton className="col-span-12" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
        <RightSection>
          <CardContainer right>
            <SectionHeadingSkeleton withIcon={false} />
            <TermsConditionsLoader />
          </CardContainer>
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
